module.exports = __webpack_public_path__ + "media/customizations/svlaliving/back-927de9951397b2a82dd02573d2d4e7ef.jpg";